import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=a5cacec8"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"
import style0 from "./Suppliers.vue?vue&type=style&index=0&id=a5cacec8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports